import {Injectable} from "@angular/core";
import {ApiBaseService} from "@portal/api/api-base-service";
import {HttpClient} from "@angular/common/http";
import {Success} from "@portal/api/responses/api-response";
import {CatalogProduct} from "@portal/api/contracts/catalog-products/catalog-product";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class CatalogProductsService extends ApiBaseService {
    controller = 'catalog-products';

    constructor(public http: HttpClient) {
        super(http);
    }

    getCatalogs(): Observable<Success<CatalogProduct>> {
        return this.get<Success<CatalogProduct>>(this.controller);
    }

    quoteCatalog(catalog: any): Observable<Success<boolean>> {
        return this.post<Success<boolean>, any>(catalog, this.controller + '/quote');
    }
}
